// import { CHOICES } from "../../utils/constants";
// import { getMyResult } from "../../utils/gameLogic";
// import ScoreBoard from "../ui/ScoreBoard";
// import Arena from "../ui/Arena";
// import ChoiceButton from "../ui/ChoiceButton";
// import ResultPanel from "../ui/ResultPanel";

// const GameScreen = ({ roomData, playerSlot, myChoice, onChoice, onNextRound }) => {
//   const me  = playerSlot === "p1" ? roomData.p1 : roomData.p2;
//   const opp = playerSlot === "p1" ? roomData.p2 : roomData.p1;

//   const myStoredChoice  = me?.choice;
//   const oppStoredChoice = opp?.choice;
//   const bothChose       = !!myStoredChoice && !!oppStoredChoice;

//   const result = bothChose
//     ? getMyResult(myStoredChoice, oppStoredChoice)
//     : null;

//   const statusMessage = () => {
//     if (myChoice && !oppStoredChoice) return { cls: "status-wait", msg: "✓ Locked in! Waiting for opponent..." };
//     if (!myChoice && oppStoredChoice) return { cls: "status-pick", msg: "⚡ Opponent is ready! Make your move!" };
//     if (!myChoice && !oppStoredChoice) return { cls: "status-pick", msg: "Choose your weapon!" };
//     return null;
//   };

//   const status = statusMessage();

//   return (
//     <div className="card">

//       {/* Score + Round */}
//       <ScoreBoard
//         myName={me?.name}
//         myScore={me?.score || 0}
//         oppName={opp?.name}
//         oppScore={opp?.score || 0}
//         round={roomData.round}
//       />

//       {/* Arena — shows choices */}
//       <Arena
//         myChoice={myChoice || myStoredChoice}
//         oppChoice={oppStoredChoice}
//         revealed={bothChose}
//         myName={me?.name}
//         oppName={opp?.name}
//       />

//       {/* Result or Choices */}
//       {bothChose && result ? (
//         <ResultPanel
//           result={result}
//           myChoice={myStoredChoice}
//           oppChoice={oppStoredChoice}
//           isHost={playerSlot === "p1"}
//           onNextRound={onNextRound}
//         />
//       ) : (
//         <>
//           {status && (
//             <div className={`status-bar ${status.cls}`}>{status.msg}</div>
//           )}
//           <div className="choices-grid">
//             {Object.keys(CHOICES).map(key => (
//               <ChoiceButton
//                 key={key}
//                 choice={key}
//                 selected={myChoice === key}
//                 disabled={!!myChoice}
//                 onClick={onChoice}
//               />
//             ))}
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default GameScreen;


import { CHOICES } from "../../utils/constants";
import ScoreBoard  from "../ui/ScoreBoard";
import Arena       from "../ui/Arena";
import ChoiceButton from "../ui/ChoiceButton";
import ResultPanel  from "../ui/ResultPanel";

// All game state comes directly from useGame hook via App.jsx
const GameScreen = ({
  roomData,
  playerSlot,
  // From useGame:
  myChoice,
  myStoredChoice,
  oppStoredChoice,
  bothChose,
  result,
  showResult,
  locked,
  oppReady,
  me,
  opp,
  onChoice,
  onNextRound,
}) => {

  // Status bar message
  const statusMessage = () => {
    if (locked && !bothChose) return { cls: "status-wait", msg: "✓ Locked in! Waiting for opponent..." };
    if (!locked && oppReady)  return { cls: "status-pick", msg: "⚡ Opponent is ready! Make your move!" };
    if (!locked && !oppReady) return { cls: "status-pick", msg: "Choose your weapon!" };
    return null;
  };

  const status = statusMessage();

  return (
    <div className="card">

      {/* Scoreboard */}
      <ScoreBoard
        myName={me?.name}
        myScore={me?.score || 0}
        oppName={opp?.name}
        oppScore={opp?.score || 0}
        round={roomData.round}
      />

      {/* Arena */}
      <Arena
        myChoice={myChoice || myStoredChoice}
        oppChoice={oppStoredChoice}
        revealed={bothChose}
        myName={me?.name}
        oppName={opp?.name}
      />

      {/* Result panel OR choice buttons */}
      {showResult && result ? (
        <ResultPanel
          result={result}
          myChoice={myStoredChoice}
          oppChoice={oppStoredChoice}
          isHost={playerSlot === "p1"}
          onNextRound={onNextRound}
        />
      ) : (
        <>
          {status && (
            <div className={`status-bar ${status.cls}`}>{status.msg}</div>
          )}
          <div className="choices-grid">
            {Object.keys(CHOICES).map(key => (
              <ChoiceButton
                key={key}
                choice={key}
                selected={myChoice === key}
                disabled={locked}
                onClick={onChoice}
              />
            ))}
          </div>
        </>
      )}

    </div>
  );
};

export default GameScreen;